export default __webpack_public_path__ + "static/media/cyrup_bg.33e4d5ae.jpg";